
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2073.737-1768.916a.694.694 0 110-1.387h4.043v-5.439a.684.684 0 01.684-.684.682.682 0 01.5.2.659.659 0 01.2.483v6.133a.67.67 0 01-.2.493.682.682 0 01-.5.2zm4.736 8.408a9.111 9.111 0 003.672-.747 9.726 9.726 0 005.079-5.075 9.43 9.43 0 000-7.334 9.731 9.731 0 00-5.093-5.086 9.406 9.406 0 00-7.324 0 9.731 9.731 0 00-5.083 5.083 9.4 9.4 0 00.007 7.337 9.758 9.758 0 005.08 5.075 9.087 9.087 0 003.663.747z"}})])])
          )
        }
      }
    